var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialX01 = function SvgSocialX01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social_x-01_svg2__a",
    x1: 7.86,
    x2: 189.86,
    y1: 174.04,
    y2: 28.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social_x-01_svg2__a",
    id: "social_x-01_svg2__b",
    x1: 7.8,
    x2: 189.8,
    y1: 173.97,
    y2: 27.97
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m106.69 96.6-5.39-7.71-34.62-49.53H48.21l42.9 61.37 5.39 7.71 36.73 52.53h18.47l-45.01-64.38z",
    style: {
      fill: "url(#social_x-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.39 0H21.61C9.68 0 0 9.68 0 21.61v156.78C0 190.32 9.68 200 21.61 200h156.78c11.93 0 21.61-9.68 21.61-21.61V21.61C200 9.68 190.32 0 178.39 0m-50.82 169.6L90.4 115.51 43.87 169.6H31.84l53.22-61.86-53.22-77.45h40.59l35.19 51.22 44.06-51.22h12.03l-50.75 58.99 55.19 80.32z",
    style: {
      fill: "url(#social_x-01_svg2__b)"
    }
  }));
};
export default SvgSocialX01;